<template lang="pug">
    div        
        filters
            slot(slot="statistics")
                base-statistics
                    slot(slot="total")
                        span {{ recipients.query_total ? recipients.query_total : 0 }}
            slot(slot="filters")      
                template(v-if="seesAllGroups")
                    select-option.w-150(
                        name="group" 
                        :options="USER_GROUPS" 
                        :predefined="USER_GROUPS[0].name"
                        @value="onGroup"
                    )          
                input.border.caret-inherit.pl-2.pr-2.h-10(type="text" v-model="search" placeholder="телефон или ФИО")
                checkbox.items-center(:checked="excludeSentToZup" @value="excludeSentToZup = $event")
                    .ml-2.text-sm.cursor-pointer.whitespace-nowrap(@click="excludeSentToZup = !excludeSentToZup") Без отправленных в ЗУП
            slot(slot="buttons")
                add-recipient
                get-sms-balance(v-if="isAdmin")
        recipients-list(:filters="filters" :search="search")
</template>

<script>
//Components
import Filters from '@/components/common/filters';
import RegularButton from '@/components/common/buttons/regular-button';
import RecipientsList from '@/components/views/recipients/';
import BaseStatstics from '@/components/common/filters/base-statistics';
import AddRecipient from '@/components/views/recipients/add-recipient';
import GetSMSBalance from '@/components/common/sms/balance';
import SelectOption from '@/components/common/forms/select-option';
import Checkbox from '@/components/common/checkbox';
//Config
import { BUTTONS_VALUES } from '@/configs/names.js';
import { USER_GROUPS } from '@/configs/user-groups';
//Store
import { RecipientsNameSpace, RecipientsGetterTypes } from '@/store/recipients/types';
import { AuthorizationNameSpace, AuthorizationGetterTypes } from '@/store/authorization/types';

export default {
    name: "RecipientsListPage",
    components: {
        'filters': Filters,
        'regular-button': RegularButton,
        'recipients-list': RecipientsList,
        'base-statistics': BaseStatstics,
        'add-recipient': AddRecipient,
        'get-sms-balance': GetSMSBalance,
        'select-option': SelectOption,
        'checkbox': Checkbox,
    },
    data() {
        return {
            //filters
            filters: {
                role: null,
                group: null,
            },
            search: '',
            excludeSentToZup: false,
        }
    },
    computed: {
        BUTTONS_VALUES() {
            return BUTTONS_VALUES
        },
        recipients() {
            return this.$store.getters[`${RecipientsNameSpace}/${RecipientsGetterTypes.GetResponse}`]
        },
        USER_GROUPS() {
            const result = [{ 
                    name: 'Все группы',
                    value: '',
                    selected: true, 
                    disabled: true, 
                    hidden: true,
                }
            ]
            const filtered_groups = USER_GROUPS.filter(g => { return g.value !== 1 })
            return [...result, ...filtered_groups]
        },
        userRole() {
            return Number(this.$store.getters[`${AuthorizationNameSpace}/${AuthorizationGetterTypes.GetRole}`])
        },
        seesAllGroups() {
            return this.userRole === 1 || this.userRole === 2 || this.userRole === 6
        },
        isAdmin() {
            return this.userRole === 1 || this.userRole === 2
        },
    },
    methods: {
        onGroup(val) {
            if (val === 'Все группы') {
                this.filters.group = null
            } else {
                this.filters.group = this.USER_GROUPS.find(g => g.name === val).value
            }
            this.search = ''
        },
    },
    watch: {
        excludeSentToZup(value) {
            const next = { ...this.filters }
            if (value) {
                next.exclude_sent_to_zup = true
            } else {
                delete next.exclude_sent_to_zup
            }
            this.filters = next
        },
    },
}
</script>